export default class Accordion {
  constructor(selector) {
    const blocks = document.querySelectorAll(
      selector ? selector : '.block-accordion'
    )
    if (!blocks) return
    this.onToggle = null

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('.js-accordion-trigger')

      if (trigger) {
        e.preventDefault()

        trigger.classList.toggle('is-active')
        if (this.onToggle) this.onToggle.call()
      }
    })
  }
}
